import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getTooltips } from '@/api/insights';
import { getSafeError } from '@/stores/insights/helpers';
import { getEnvironment } from '@/helpers/environment';
import { useAppSnackbar } from '@/stores/app/snackbar';

export const useTooltips = defineStore('tooltips', () => {
  const tooltips = ref({});

  const setTooltips = (value) => {
    tooltips.value = value;
  };

  const loadTooltips = async (tooltipKeys) => {
    try {
      const newTooltips = await getTooltips(tooltipKeys);

      setTooltips(newTooltips);
    } catch (error) {
      const safeError = getSafeError(error);
      const environment = getEnvironment();

      // In development we know tooltips aren't available
      if (environment === 'development') return;

      useAppSnackbar().addErrorSnackbar({
        text: `Unable to load tooltips - ${safeError}`,
      });

      throw error;
    }
  };

  return {
    tooltips,
    setTooltips,
    loadTooltips,
  };
});
